import React from 'react';
import { Waves, PhoneCall, MapPin, Mail, ShieldCheck, Heart } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-950 text-slate-400 border-t border-slate-800 text-xs py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          <div className="space-y-3 md:col-span-1">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-xl bg-sky-600 text-white flex items-center justify-center font-bold">
                <Waves className="w-5 h-5" />
              </div>
              <span className="text-base font-bold text-white tracking-tight">长顺县游泳协会</span>
            </div>
            <p className="text-slate-400 leading-relaxed text-[11px]">
              贵州省黔南州长顺县游泳水上运动推广与防溺水普及单位。构建集赛事报名、会员服务、证书核验与安全教育为一体的数字化平台。
            </p>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold text-white text-sm border-b border-slate-800 pb-2">场馆与联系方式</h4>
            <div className="space-y-1.5 text-slate-300">
              <p className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-sky-400 shrink-0" /> 长顺县长州路全民健身中心游泳馆</p>
              <p className="flex items-center gap-1.5"><PhoneCall className="w-3.5 h-3.5 text-sky-400 shrink-0" /> 协会热线: 0854-6821999</p>
              <p className="flex items-center gap-1.5"><Mail className="w-3.5 h-3.5 text-sky-400 shrink-0" /> 邮箱: csxswim@163.com</p>
            </div>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold text-white text-sm border-b border-slate-800 pb-2">水上紧急救援热线</h4>
            <div className="space-y-1.5 text-slate-300 font-mono">
              <p className="text-red-400 font-bold">长顺水上救援队: 0854-6821999</p>
              <p>公安报警电话: 110</p>
              <p>医疗急救电话: 120</p>
            </div>
          </div>

          <div className="space-y-2">
            <h4 className="font-bold text-white text-sm border-b border-slate-800 pb-2">备案与合规声明</h4>
            <div className="space-y-1.5 text-slate-400 text-[11px]">
              <p>指导单位: 长顺县文体广电旅游局</p>
              <p>支持支付: 微信支付 (WeChat Pay V3) 认证商户</p>
              <p className="flex items-center gap-1 text-emerald-400 font-semibold"><ShieldCheck className="w-3.5 h-3.5" /> 黔ICP备20260815号-1</p>
            </div>
          </div>

        </div>

        <div className="pt-6 border-t border-slate-800/80 flex flex-col sm:flex-row justify-between items-center gap-3 text-slate-500 text-[11px]">
          <div>
            © 2026 长顺县游泳协会 (Changshun County Swimming Association). All Rights Reserved.
          </div>
          <div className="flex items-center gap-1 text-slate-400">
            <span>用心为全县游泳爱好者服务</span>
            <Heart className="w-3 h-3 text-rose-500 fill-rose-500" />
          </div>
        </div>

      </div>
    </footer>
  );
};
